import { z } from "zod";

import { PAGE_PARAM_NAME, SEARCH_TERM_PARAM_NAME } from "./constants";

/**
 * Combines a current URL Query (location.search) with a searchTerm and page.
 * If either of the latter are not provided, they will be removed from the original provided query.
 * @returns string
 */
export const getQueryString = ({
    currentQuery,
    searchTerm,
    page,
}: {
    currentQuery?: string; // '?exampleParam=true'
    searchTerm?: string;
    page?: number;
}) => {
    const query = new URLSearchParams(currentQuery);

    if (searchTerm) {
        query.set(SEARCH_TERM_PARAM_NAME, searchTerm);
    } else {
        query.delete(SEARCH_TERM_PARAM_NAME);
    }

    if (page && page > 1) {
        query.set(PAGE_PARAM_NAME, page.toString());
    } else {
        query.delete(PAGE_PARAM_NAME);
    }

    return query.toString();
};

export const SearchSchema = z.object({
    searchTerm: z.string().min(3, {
        message: "Enter 3 characters or more",
    }),
});
